import { addSeconds } from 'date-fns'
import { formatDateWithFormat, ignoreTimezoneDate } from '../../helpers/date'
import { IBookingModel } from '../../interfaces/models/bookings.interfaces'

export function getTimeSpanString(booking: IBookingModel): string {
  return `${formatDateWithFormat(
    ignoreTimezoneDate(new Date(booking.startDate)),
    'HH:mm'
  )}-${formatDateWithFormat(
    // Backend stores the value as 15:59:59 instead of 16:00.
    addSeconds(ignoreTimezoneDate(new Date(booking.endDate)), 1),
    'HH:mm'
  )}`
}
